import { defineComponent, ref } from 'vue';
import FlowGrid from '@/components/FlowGrid/index.vue';
import Cases from '@/components/Cases/index.vue';
import Banner from '@/components/Banner2';
import SmartTitle from '../../../components/SmartTitle/index.vue';
import Card from './components/Card.vue';
import FunctionCard from './components/FunctionCard.vue';
import BrightSpot from './components/BrightSpot.vue';
import Appointment2 from '@/components/Appointment2/index.vue';
export default defineComponent({
  components: {
    FlowGrid,
    Banner,
    Cases,
    SmartTitle,
    Card,
    FunctionCard,
    BrightSpot,
    Appointment2
  },
  setup() {
    const bannerUrl = require('@/assets/images/outboundCallingBot-banner.png');
    const compareList = [{
      icon: require('@/assets/images/service/outbound-calling/effective1.png'),
      title: '培训周期长',
      desc: '销售人员业务能力参差不齐导致业务培训成本高,业务变动快会带来成本提升'
    }, {
      icon: require('@/assets/images/service/outbound-calling/effective2.png'),
      title: '运营成本高',
      desc: '员工成本高,场地成本持续上涨外呼成本最低0.8元/通电话'
    }, {
      icon: require('@/assets/images/service/outbound-calling/effective3.png'),
      title: '市场变化快',
      desc: '市场竞争激烈,业务随时根据市场动态进行调整'
    }, {
      icon: require('@/assets/images/service/outbound-calling/effective4.png'),
      title: '数据不准确',
      desc: '人为记录数据质量无法保证撞单重复甚至造成客户无法挽回'
    }, {
      icon: require('@/assets/images/service/outbound-calling/effective5.png'),
      title: '客户难寻',
      desc: '客户防骚扰意识逐渐增强外呼的挂断率居高不下,呼叫人员工作效率低'
    }, {
      icon: require('@/assets/images/service/outbound-calling/effective6.png'),
      title: '人员流动大',
      desc: '电销离职率保守估计50%以上,增加重新培训成本'
    }];
    const effectives = [{
      title: '自动拨号',
      desc: ['一键导入号码', '定制呼叫策略'],
      icon: require('@/assets/images/service/outbound-calling/function1.png')
    }, {
      title: '智能对话',
      desc: ['真人语音交互', '专业话术流程', '支持随时打断'],
      icon: require('@/assets/images/service/outbound-calling/function2.png')
    }, {
      title: '精确分级',
      desc: ['自动判断意向', '锁定精准客户', '及时二次跟进'],
      icon: require('@/assets/images/service/outbound-calling/function3.png')
    }, {
      title: '自动记录',
      desc: ['记录完整保存', '方便人工查看'],
      icon: require('@/assets/images/service/outbound-calling/function4.png')
    }, {
      title: '数据分析',
      desc: ['任务数据清晰呈现', '帮助企业查询管理'],
      icon: require('@/assets/images/service/outbound-calling/function5.png')
    }, {
      title: '机器学习',
      desc: ['不断积累总结', '自动更新维护'],
      icon: require('@/assets/images/service/outbound-calling/function6.png')
    }];
    const smartList = {
      left: [{
        title: '语音识别',
        desc: '采用同花顺自研语音识别引擎，识别效果可根据客户业务进行优化'
      }, {
        title: '拟人化合成',
        desc: '支持使用定制声音模型进行合成，模拟真人业务员的同时降低录音成本。'
      }],
      right: [{
        title: '语义理解',
        desc: '自研新一代相似句技术，长句识别效果更好，后期维护成本更低。'
      }, {
        title: '意向分类',
        desc: '可自定义意向分类，相比一般的ABCD类，更加贴近客户业务场景。'
      }]
    };
    const auditions = [{
      title: '来电提醒',
      desc: '通知客户所购买的保险有效。',
      id: 'welcome'
    }, {
      title: '付款提醒',
      desc: '当客户的付款截止日期临近时，会发出电话提醒。',
      id: 'pay'
    }, {
      title: '订婚电话',
      desc: '在客户的生日，打电话给客户并发送生日祝福。',
      id: 'birthday'
    }];
    const audioEl = ref(null);
    const audioResourse = ref('');
    const playing = ref(false);
    const audio = ref('');
    function playAudio(id) {
      switch (id) {
        case 'welcome':
          audioEl.value.src = require('@/assets/audio/welcome.mp3');
          break;
        case 'pay':
          audioEl.value.src = require('@/assets/audio/pay.mp3');
          break;
        case 'birthday':
          audioEl.value.src = require('@/assets/audio/birthday.mp3');
      }
      playing.value = true;
      audio.value = id;
      if (audioEl.value) {
        audioEl.value.play();
      }
    }
    function onPause() {
      audio.value = '';
      playing.value = false;
      audioEl.value.src = '';
    }
    return {
      bannerUrl,
      effectives,
      smartList,
      compareList,
      auditions,
      audioEl,
      audioResourse,
      playing,
      audio,
      playAudio,
      onPause
    };
  }
});